import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api/api.service';
import { FlashService } from '@app/services/flash.service';

import { LogsActionTypes, ExportLogs } from '@core/actions/logs.actions';

import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class LogsEffects {
  @Effect({ dispatch: false })
  exportLogs$ = this.actions$.pipe(
    ofType<ExportLogs>(LogsActionTypes.ExportLogs),
    map(action => [action.data1, action.data2]),
    tap(
      ([date1, date2]) => this.api.exportLogs(date1, date2),
      tap(() => console.log('done'))
    )
  );

  constructor(
    private actions$: Actions,
    private api: ApiService // private fs: FlashService
  ) {}
}
